import { AllCategoriesView } from "../AllCategoriesView";
import styles from "../MobileProductFilter/styles.module.scss";

export const MobileAllCatgories = ({ closeModal = () => {} }) => {
  return (
    <section aria-label="Categories">
      <div className={styles.category}>
        <AllCategoriesView closeModal={closeModal} isMobileView={true} />
      </div>
    </section>
  );
};
